/**
 * Format a timestamp into a readable date/time string.
 * @param timestamp - Milliseconds since epoch (defaults to now).
 * @returns Formatted string like "Jan 25, 2026, 12:24".
 */
export function formatTimestamp(timestamp: number = Date.now()): string {
  return new Date(timestamp).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

/**
 * Format file size in bytes to human-readable format.
 * @param bytes - File size in bytes.
 * @returns Formatted string like "1.5 MB" or "256 KB".
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 B";

  const units = ["B", "KB", "MB", "GB", "TB"];
  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = bytes / Math.pow(k, i);

  return `${size.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

